const routes = [
  // {
  //   path: "/content",
  //   name: authCodeMap.content,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/content/classify",
  //   meta: {
  //     title: "内容管理",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.content,
  //   },
  //   children: [
  //     {
  //       path: "classify",
  //       name: authCodeMap.content_classify,
  //       component: (): any => import("@/modules/content/pages/classify/index.vue"),
  //       meta: {
  //         title: "内容_内容管理_分类管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_classify,
  //       },
  //     },
  //     {
  //       path: "label",
  //       name: authCodeMap.content_label,
  //       component: (): any => import("@/modules/content/pages/label/index.vue"),
  //       meta: {
  //         title: "内容_内容管理_标签管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_label,
  //       },
  //     },
  //     {
  //       path: "clinic",
  //       name: authCodeMap.content_clinic,
  //       component: (): any => import("@/modules/content/pages/clinic/index.vue"),
  //       meta: {
  //         title: "内容_内容采集_诊室文章",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_clinic,
  //       },
  //     },
  //     {
  //       path: "liveCollection",
  //       name: authCodeMap.content_liveCollection,
  //       component: (): any => import("@/modules/content/pages/liveCollection/index.vue"),
  //       meta: {
  //         title: "内容_内容采集_直播采集",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_liveCollection,
  //       },
  //     },
  //     {
  //       path: "specialTopic",
  //       name: authCodeMap.content_special_topic,
  //       component: (): any => import("@/modules/content/pages/specialTopic/index.vue"),
  //       meta: {
  //         title: "内容_内容采集_专题管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_special_topic,
  //       },
  //     },
  //     {
  //       path: "specialTopic_edit",
  //       name: authCodeMap.content_special_topic_edit,
  //       component: (): any => import("@/modules/content/pages/specialTopic/edit.vue"),
  //       meta: {
  //         title: "内容_内容采集_专题管理_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_special_topic_edit,
  //       },
  //     },
  //     {
  //       path: "all/edit",
  //       name: authCodeMap.content_allEdit,
  //       component: (): any => import("@/modules/content/pages/all/edit/index.vue"),
  //       meta: {
  //         title: "内容_内容管理_社区内容_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_allEdit,
  //       },
  //     },
  //     {
  //       path: "all/index",
  //       name: authCodeMap.content_allIndex,
  //       component: (): any => import("@/modules/content/pages/all/index.vue"),
  //       meta: {
  //         title: "内容_内容管理_社区内容",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_allIndex,
  //       },
  //     },
  //     {
  //       path: "qa",
  //       name: authCodeMap.content_qa,
  //       component: (): any => import("@/modules/content/pages/qa/index.vue"),
  //       meta: {
  //         title: "运营_圈子管理_问答管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_qa,
  //       },
  //     },
  //     {
  //       path: "live",
  //       name: authCodeMap.content_live,
  //       component: (): any => import("@/modules/content/pages/live/ScienceLiveManagePage.vue"),
  //       meta: {
  //         title: "科普直播",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.content_live,
  //       },
  //     },
  //     {
  //       path: "live/edit",
  //       name: "scienceEditLive",
  //       component: (): any => import("@/modules/content/pages/live/edit/ScienceEditLivePage.vue"),
  //       meta: {
  //         title: "科普直播",
  //         hidden: true,
  //         needLogin: true,
  //       },
  //     },
  //   ],
  // },
];
export default routes;